<script lang="ts">
    import { onDestroy, onMount } from "svelte";
    import { gtm } from "$lib/config/nucamp.client.json";
    import { utnTracking } from "$lib/client/services/window";
    import { syncTraffic } from "$lib/client/services/user";
    import { get } from "svelte/store";
    import { user } from "$lib/client/stores/nucamp-user";
		// import * as Sentry from '@sentry/sveltekit';


		function setGoogleTagManager() {
			window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
						"gtm.start": new Date().getTime(),
						event: "gtm.js",
				});
				const gtmScript = document.createElement("script");
				gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=" + gtm.containerId;
				document.head.append(gtmScript);
		}

		// async function setSentrySessionRecording() {
		// 	const {replayIntegration} = await import('@sentry/sveltekit');

		// 	Sentry.addIntegration(replayIntegration({
		// 		maskAllText: false,
		// 		blockAllMedia: false,
		// 	}));
		// }

    onMount(() => setTimeout(() => {
			setGoogleTagManager();
			// setSentrySessionRecording();
		}, 3000));

		// Set first visit timestamp
		const fv = window.localStorage.getItem('firstVisit');
		if (!fv) {
				window.localStorage.setItem('firstVisit', new Date().toISOString())
		}

		// Catch Ads UTN
		utnTracking();

    onDestroy(() => {
        const nucampUser = get(user);
        syncTraffic(nucampUser);
    });
</script>